import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, ArrowLink } from "@/components/kit";
import { Reveal } from "@/lib/anim";

const CARDS = [
  { to: "/tools/landed-cost-and-margin-calculator", eyebrow: "Interactive", h: "Landed cost and margin calculator", p: "Model factory price, freight, duty, GST and your discount rate, then see the intake and achieved margin left. Email the numbers to yourself." },
  { to: "/tools/downloads", eyebrow: "Free downloads", h: "Checklists and question lists", p: "The first production run checklist, the factory questions list, the landed cost worksheet and the tech pack checklist, as branded PDFs." },
  { to: "/guides/first-production-run-australia", eyebrow: "Guide", h: "First production run in Australia", p: "A step-by-step walk through of costing, quantities and sourcing for a first order landing into Australia." },
];

export default function Tools() {
  return (
    <>
      <Seo title="Tools — Landed Cost Calculator & Downloads" canonical="/tools" description="Free tools for fashion and consumer product founders: a GST-aware landed cost and margin calculator, downloadable checklists, and a first production run guide for Australian brands." keywords="landed cost calculator, margin calculator, garment costing, tech pack checklist, first production run guide, fashion sourcing tools" />
      <PageHero
        eyebrow="Tools"
        crumbs={[{ label: "Home", to: "/" }, { label: "Tools" }]}
        title="Work out the number before you ask anyone for advice."
        lead="Three tools, all free, all built for Australian brands in Australian dollars. The calculator needs no sign-up. The downloads need an email address, and that is the only thing they cost."
      />
      <Section bg="bone">
        <div className="grid md:grid-cols-3 gap-6">
          {CARDS.map((c, i) => (
            <Reveal i={i} key={c.to}>
              <Link to={c.to} className="card block h-full p-8" data-testid={`tool-card-${i}`}>
                <span className="eyebrow">{c.eyebrow}</span>
                <h2 className="t-h3 mt-4">{c.h}</h2>
                <p className="t-sm text-[var(--muted)] mt-4">{c.p}</p>
                <span className="lnk mt-7 inline-flex">Open<span className="arrow-anim">→</span></span>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
}
